const demo_app = {
    notification: 'Tip: Create an account first to test the sign-in experience.',
};
export default Object.freeze(demo_app);
